/**
 * Edit this array to add or remove discount codes
 */
const discount_codes = [
  {
    code: "BEOFITLIVE",
    percentage: 15,
  },
  {
    code: "EMPTY",
    percentage: 0,
  },
  {
    code: "EMPTY",
    percentage: 0,
  },
  {
    code: "EMPTY",
    percentage: 0,
  },
];

/**
 * Don't Edit below this line
 */

const DiscountFrontend = (() => {
  const STORAGE_KEY = "discountCode";
  const APPLIED_KEY = "discountApplied";

  const getDiscount = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("discount") || localStorage.getItem(STORAGE_KEY);
  };

  const applyDiscountToSession = () => {
    const params = new URLSearchParams(window.location.search);
    const discount = params.get("discount");

    if (discount && sessionStorage.getItem(APPLIED_KEY) !== discount) {
      localStorage.setItem(STORAGE_KEY, discount);
      sessionStorage.setItem(APPLIED_KEY, discount);

      // Redirect through Shopify discount URL to apply to session
      const currentPath = window.location.pathname;
      window.location.href = `/discount/${discount}?redirect=${currentPath}?discount=${discount}`;
    }
  };

  const showDiscountNotification = () => {
    const params = new URLSearchParams(window.location.search);
    const discount = params.get("discount");
    const appliedDiscount = sessionStorage.getItem(APPLIED_KEY);

    if (discount && appliedDiscount === discount) {
      const notification = document.createElement("div");
      notification.className = "discount-applied";
      notification.textContent = `Discount code ${discount} applied!`;

      document.body.appendChild(notification);

      // Auto-hide after 5 seconds
      setTimeout(() => {
        notification.style.opacity = "0";
        setTimeout(() => notification.remove(), 300);
      }, 5000);
    }
  };

  const redirectToCheckoutWithDiscount = (checkoutUrl = "/checkout") => {
    const discount = getDiscount();
    if (discount) {
      window.location.href = `/discount/${discount}?redirect=${checkoutUrl}`;
    } else {
      window.location.href = checkoutUrl;
    }
  };

  const updatePricesWithDiscount = () => {
    const params = new URLSearchParams(window.location.search);
    const discountCode = params.get("discount");
    if (!discountCode) return;

    // Find the discount percentage
    const discountData = discount_codes.find(
      (d) => d.code.toUpperCase() === discountCode.toUpperCase()
    );
    if (!discountData) return;

    const percentage = discountData.percentage;

    // Find all price elements with class "amount"
    const priceElements = document.querySelectorAll("span.amount");

    priceElements.forEach((priceSpan) => {
      if (priceSpan.hasAttribute("data-discount-applied")) return;

      if (priceSpan.closest(".total")) return;

      const originalPriceText = priceSpan.textContent.trim();

      const priceMatch = originalPriceText.match(/[\d.,]+/);
      if (!priceMatch) return;

      const originalPrice = parseFloat(priceMatch[0].replace(",", "."));
      const discountedPrice =
        Math.ceil(originalPrice * (1 - percentage / 100) * 100) / 100;

      // Create del element with original price
      const delElement = document.createElement("del");
      delElement.textContent = originalPriceText;
      delElement.style.marginRight = "8px";
      delElement.style.fontSize = "0.8em";
      delElement.style.opacity = "0.6";

      priceSpan.parentNode.insertBefore(delElement, priceSpan);

      const currencySymbol = originalPriceText.replace(/[\d.,\s]/g, "").trim();
      priceSpan.textContent = `${currencySymbol}${discountedPrice
        .toFixed(2)
        .replace(".", ",")}`;

      priceSpan.setAttribute("data-discount-applied", "true");
    });
  };

  const observePriceChanges = () => {
    const observer = new MutationObserver((mutations) => {
      const hasNewPrices = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType === 1) {
            return (
              node.matches?.("span.amount") ||
              node.querySelector?.("span.amount")
            );
          }
          return false;
        })
      );

      if (hasNewPrices) {
        updatePricesWithDiscount();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  const preserveDiscountInLinks = () => {
    const params = new URLSearchParams(window.location.search);
    const discount = params.get("discount");

    if (!discount) return;

    document.addEventListener(
      "click",
      (e) => {
        const link = e.target.closest("a");
        if (!link) return;

        const href = link.getAttribute("href");
        if (
          !href ||
          href.startsWith("#") ||
          href.startsWith("mailto:") ||
          href.startsWith("tel:")
        )
          return;

        // Skip external links
        if (link.hostname && link.hostname !== window.location.hostname) return;

        // Skip if already has discount parameter
        if (href.includes("?discount=") || href.includes("&discount=")) return;

        // Add discount parameter
        const separator = href.includes("?") ? "&" : "?";
        link.setAttribute("href", `${href}${separator}discount=${discount}`);
      },
      true
    );
  };

  return {
    applyDiscountToSession,
    redirectToCheckoutWithDiscount,
    showDiscountNotification,
    updatePricesWithDiscount,
    observePriceChanges,
    preserveDiscountInLinks,
  };
})();

// Apply discount on page load
document.addEventListener("DOMContentLoaded", () => {
  DiscountFrontend.applyDiscountToSession();
  DiscountFrontend.showDiscountNotification();
  DiscountFrontend.updatePricesWithDiscount();
  DiscountFrontend.observePriceChanges();
  DiscountFrontend.preserveDiscountInLinks();
});

// Intercept checkout buttons
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[name="checkout"]').forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const discount =
        new URLSearchParams(window.location.search).get("discount") ||
        localStorage.getItem("discountCode");
      if (discount) {
        e.preventDefault();
        DiscountFrontend.redirectToCheckoutWithDiscount();
      }
    });
  });
});
